import { DEFAULT_SEARCH_STATE, serializeSearchState, type SearchState } from './search-query';

/**
 * URL builder for the one-and-only search pipeline.
 *
 * A predefined query (a mega-menu item, a marketing link, a preset route) is
 * just a partial {@link SearchState}. This serialises it with the SAME
 * `serializeSearchState` the results page parses back via `useSearchState`, so
 * a generated link behaves identically to a user typing the query into the Hero
 * search bar — same URL params, same state, same API. `path` chooses the
 * SEO-friendly landing route (`/inventory`, `/search`, …); the
 * results page reads the params regardless of which of these it renders under.
 */
export function buildSearchUrl(path: string, filters: Partial<SearchState> = {}): string {
  const qs = serializeSearchState({ ...DEFAULT_SEARCH_STATE, ...filters }).toString();
  return qs ? `${path}?${qs}` : path;
}
